import { OrgUnitCascaderValue, orgUnitCascaderValue } from "../../utils";
import { Cascader, CascaderProps } from "antd";
import React from "react";
import { useTaxonomyLabel } from "~/context/taxonomy-context";
import { ORGANISATIONAL_UNITS_QUERY } from "~/graphql/query";
import { useQuery } from "@apollo/client";

type Option = {
  value: number;
  label: string;
  children: {
    value: number;
    label: string;
  }[];
}[];

export type PACascaderProps = {
  selectedId?: number;
  allowClear?: boolean;
  onChange?: (val: any, paOptions: Option) => any;
} & CascaderProps;
const orgUnitFromCascadeValue = (value: OrgUnitCascaderValue): number => {
  if (typeof value === "number") {
    return value;
  }

  if (!value) {
    return 0;
  }

  if (value?.[0] && value?.[1]) {
    return value[1];
  }

  if (value?.[0]) {
    return value[0];
  }

  return 0;
};

export const PracticeAreasCascader: React.FC<PACascaderProps> = ({
  onChange,
  allowClear,
  selectedId,
  ...props
}) => {
  const taxonomy = useTaxonomyLabel();
  const { data: practiceAreas, loading: paLoading } = useQuery(ORGANISATIONAL_UNITS_QUERY);

  const paOptions = practiceAreas?.organisationalUnits
    .filter((x) => !x.parent?.id)
    .map((pa) => {
      return {
        value: pa.id,
        label: pa.name,
        children: pa.children?.map((y) => ({ value: y.id, label: y.name })) || [],
      };
    });

  return (
    <Cascader
      style={{ marginBottom: 5, width: "100%" }}
      loading={paLoading}
      onChange={(val: any) => {
        const target = orgUnitFromCascadeValue(val);

        if (!paOptions) {
          return;
        }

        onChange && onChange(target, paOptions);
      }}
      defaultValue={orgUnitCascaderValue(practiceAreas?.organisationalUnits ?? [], selectedId)}
      placeholder={`Select ${taxonomy.PracticeArea}`}
      options={paOptions}
      showSearch={true}
      allowClear={allowClear}
      {...props}
    />
  );
};
